import { useFormContext } from 'react-hook-form';

import { type QConfigGeneratorCreationFormInput } from './schema';

function useQConfigGeneratorCreationForm() {
  const context = useFormContext<QConfigGeneratorCreationFormInput>();

  if (!context) {
    throw new Error(
      'useQConfigGeneratorCreationForm must be used within a QConfigGeneratorCreationFormProvider',
    );
  }

  return context;
}

export { useQConfigGeneratorCreationForm };
